import cn from 'classnames';
import { memo } from 'react';
import { useParams } from 'react-router-dom';
import { IModule } from '@api/types/general';
import { IBlackjackGame, IBlackjackRoom } from '@api/types/blackjack';
import { getRoomGames } from '@utils/blackjack';
import RoomGames from '../components/room-games';
import useReduxState from '@hooks/useReduxState';
import styles from './more-games.module.scss';

const MAX_PLAYERS: number = 5;

const MoreGames = ({ className = '' }: IModule): JSX.Element => {
  const { gameUid } = useParams();
  const [rooms] = useReduxState((state) => state.blackjackLobby.rooms);

  if (!rooms.length) return <></>;

  const room: IBlackjackRoom | undefined = rooms.find(
    (room) => room.max_players === MAX_PLAYERS
  );

  if (!room) return <></>;

  const roomGames: IBlackjackGame[] = getRoomGames(room, gameUid);

  if (!roomGames.length) return <></>;

  return (
    <section className={cn(styles.container, className)}>
      <h2>Available games</h2>
      <RoomGames
        className={styles.container__games}
        currentGameUid={gameUid}
        {...{ room }}
      />
    </section>
  );
};

export default memo(MoreGames);
